import { gql } from "@apollo/client";

export const GET_PMV_STATUS = gql`
    query MyQuery {
        its_pmv_statuses(order_by: [{pmv_id: asc}, {created_at: desc}], distinct_on: pmv_id) {
            message
            id
            pmv_id
            created_at
            is_online
        }
    }
`;

export const GET_PMV_STATUSES = (
    page?: number,
    pageSize?: number,
    orderBy: "asc" | "desc" = "desc",
    startDate?: string,
    endDate?: string
) => {
    // Paginación
    // Si no se pasa pageSize o page, no se aplica paginación
    const paginationArgs = pageSize && page
        ? `, limit: ${pageSize}, offset: ${(page ? (page - 1): 0) * pageSize}`
        : "";

    // Filtros para condición where
    const filters: string[] = [];

    // Rango de fechas
    if (startDate || endDate) {
        const dateConditions = [];
        if (startDate) dateConditions.push(`_gte: "${startDate}"`);
        if (endDate) dateConditions.push(`_lte: "${endDate}"`);
        // Si hay un solo elemento en dateConditions, se agrega el operador de comparación
        filters.push(`created_at: { ${dateConditions.join(", ")} }`);
    }

    // Si hay filtros, se agrega la cláusula where
    const whereClause = filters.length > 0 ? `, where: { ${filters.join(", ")} }` : "";


    return gql`
        query MyQuery {
            its_pmv_statuses_aggregate(
                order_by: {created_at: ${orderBy}}
                ${whereClause}
            ) {
                aggregate {
                    count
                }
            }
            its_pmv_statuses(
                order_by: {created_at: ${orderBy}}
                ${whereClause}
                ${paginationArgs}
            ) {
                message
                id
                pmv_id
                pmv{
                    description
                }
                created_at
                is_online
            }
        }
    `;
}